(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('BotNotification', BotNotification);

    BotNotification.$inject = ['$resource'];

    function BotNotification ($resource) {
        var resourceUrl =  'api/bot-notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
